import { graphql } from '../../graphql';
import execute from '../../helpers/functions/api';

export const getCountriesConfig = () => {
  const query = graphql(`
    query GetManageConfig {
      getManageConfig(
        input: { configurationProfile: COUNTRY, environment: PROD }
      )
    }
  `);

  return execute({ query, withApiKey: true });
};
